import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import { deleteContacts } from '@/app/services/students/students';

const DeleteconfirmContact = ({ student, row, setStudent, setRefresh, refresh }) => {
	const [isRequesting, setIsRequesting] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className="popup">
			<div>
				<div className="icon-span">
					<h2>!</h2>
				</div>
				<h1 className="disable-text">Are you sure you want to delete ?</h1>
				{isRequesting ? (
					<CircularProgress size={35} />
				) : (
					<>
						<button className="no-disable-btn" onClick={() => dispatch(Actions.closeDialog())} type="button">
							No
						</button>
						<button
							className="no-disable-btn"
							onClick={() => {
								setIsRequesting(true);
								deleteContacts(student.id, row.id)
									.then((res) => {
										setRefresh(!refresh);
										setStudent({
											...student,
											parents: student.parents.filter((parent) => parent.id !== row.id),
											approved_pickups: student.approved_pickups.filter((parent) => parent.id !== row.id),
											extended_family: student.extended_family.filter((parent) => parent.id !== row.id),
										});
										dispatch(
											Actions.showMessage({
												message: res.data.message,
												autoHideDuration: 1500,
												variant: 'success',
											}),
										);
										dispatch(Actions.closeDialog());
									})
									.catch((err) => {
										dispatch(
											Actions.showMessage({
												message: err.response.data.message,
												variant: 'error',
											}),
										);
										dispatch(Actions.closeDialog());
									})
									.finally(() => {
										setIsRequesting(false);
									});
							}}
							type="button"
						>
							Yes
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default DeleteconfirmContact;
